if (!customElements.get('about-carousel')) {
  customElements.define(
    'about-carousel',
    class AboutCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.cards = Array.from(this.querySelectorAll('[data-carousel-card]'));
        this.onScroll = this.onScroll.bind(this);
        this.onDotClick = this.onDotClick.bind(this);
        this.onResize = this.onResize.bind(this);

        if (!this.track || this.cards.length === 0) return;

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        for (const dot of this.dots) {
          dot.addEventListener('click', this.onDotClick);
        }

        this.updateDots();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);

        for (const dot of this.dots) {
          dot.removeEventListener('click', this.onDotClick);
        }
      }

      onResize() {
        this.updateDots();
      }

      onScroll() {
        window.requestAnimationFrame(() => this.updateDots());
      }

      onDotClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        const card = this.cards[index];
        if (!card || !this.track) return;

        this.track.scrollTo({
          left: card.offsetLeft,
          behavior: 'smooth',
        });
      }

      updateDots() {
        if (!this.track || this.dots.length === 0) return;

        const {scrollLeft, scrollWidth, clientWidth} = this.track;
        const maxScroll = scrollWidth - clientWidth;
        let activeIndex = 0;

        // Once the track is scrolled fully right, the trailing cards are all already on
        // screen, so scrollLeft can never reach the last card's offsetLeft and the
        // nearest-offset match below leaves the final dot permanently unreachable
        // (QI TSK-81770). Scrolling left has no equivalent problem because scrollLeft
        // does reach 0, which is exactly the first card's offsetLeft.
        if (maxScroll > 0 && maxScroll - scrollLeft <= 1) {
          activeIndex = (this.cards.length - 1);
        } else {
          let closestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              activeIndex = index;
            }
          });
        }

        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
